<template>
    <div class="container-fluid" style="padding: 0">
         <nav class="navbar navbar-light" v-if="user" :style="{ 'background-color' : navbar_colour }">
            <a class="navbar-brand" @click="showDebugModal">
                <img :src="logo || '/images/goodtill-logo.png'" height="35" class="d-inline-block align-top" alt="">
            </a>
            <div>
                <img src="/images/goodeats-logo-alt.png" height="35" class="d-inline-block align-top" alt="">
                <span v-if="this.partner_source == 'sumup'" class="font-14 col-white pl-3"> Powered by <img src="/images/sumup-logo.png" height="25" class="d-inline-block align-top pl-2" alt=""></span>
            </div>
            <div>
                <span class="pr-4">
                    <icon class="mr-2" color='yellow' name="circle" scale="0.7" :class="{accepting: store_is_offline == 0}"></icon>
                    <span class="col-white">{{store_is_offline == 0 ? 'Receiving orders' : 'Store paused'}}</span>
                    <button type="button" class="btn btn-xs btn-accepting-orders btn-primary-outline"
                        @click="show_settings_modal = true">
                        <icon name="cog" color='whitesmoke'></icon>
                    </button>
                </span>
                <button type="button" class="btn btn-primary-outline btn-close btn-logout btn-reject p-0" @click="confirmLogout">
                    Logout
                    <icon class="ml-2" name="sign-out-alt"></icon>
                </button>
            </div>
        </nav>

        <router-view></router-view>

        <div v-if="loading">
            <transition name="modal">
            <div class="modal-mask" id="loading-mask">
                <div class="modal-wrapper">
                <div class="modal-dialog d-flex justify-content-center mx-auto" role="document">
                    <div class="modal-content mx-auto">
                        <div class="modal-body text-center mt-3 mb-3 color-grey">
                            <icon class="mr-2" scale="1.5" color="gray" name="circle-notch" spin></icon> Loading ...
                        </div>
                    </div>
                </div>
                </div>
            </div>
            </transition>
        </div>

        <div v-if="show_settings_modal" id="settings-modal">
            <transition name="modal">
                <div class="modal-mask">
                    <div class="modal-wrapper">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title">Settings</h5>
                                    <button type="button" class="close noSelect" data-dismiss="modal"
                                            aria-label="Close" @click="show_settings_modal = false"
                                    >
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div class="modal-body">

                                    <div>
                                        <label class="switch float-right">
                                            <input type="checkbox" :checked="store_is_offline == 0" @click="toggleStatus">
                                            <span class="slider round"></span>
                                        </label>
                                        <span>
                                            <p>
                                                POS Accepting Orders
                                            </p>
                                            <span class="font-14">
                                                This option only affects orders placed through Goodeats.
                                                Orders placed through external systems will still be accepted when this option is disabled.
                                            </span>
                                        </span>
                                    </div>
                                    <div class="mt-4">
                                        <span class="float-right">
                                            <label class="switch">
                                                <input type="checkbox" :checked="sound_enabled" @click="toggleSound">
                                                <span class="slider round"></span>
                                            </label>
                                        </span>
                                        <p>
                                            Enable Sound Notification
                                        </p>
                                    </div>
                                    <div class="mt-4">
                                         <span class="float-right">
                                            <label class="switch">
                                                <input type="checkbox" :checked="order_search_enabled" @click="toggleSearch">
                                                <span class="slider round"></span>
                                            </label>
                                        </span>
                                        <p>
                                            Enable Orders Search
                                        </p>
                                    </div>
                                    <div class="mt-4">
                                        <p class="custom-header-min theme-blue-dark">
                                            Collection - Dropoff Points
                                        </p>
                                    </div>
                                     <div class="mt-4">
                                         <span class="float-right">
                                            <label class="switch">
                                                <input type="checkbox"
                                                    :checked="ignore_collection_points"
                                                    @click="toggleShowAll"
                                                >
                                                <span class="slider round"></span>
                                            </label>
                                        </span>
                                        <p>
                                           Show All Orders
                                        </p>
                                    </div>
                                    <div class="ml-3" v-if="!ignore_collection_points">
                                        <div class="mt-4" v-for="point in all_collection_points" :key="point.id">
                                            <span class="float-right">
                                                <label class="switch">
                                                    <input type="checkbox"
                                                        :checked="collection_points.includes(point.id)"
                                                        @click="toggleCollectionPoint(point)"
                                                    >
                                                    <span class="slider round"></span>
                                                </label>
                                            </span>
                                            <p>
                                                {{point.point_name}}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-primary-outline btn-close"
                                            @click="show_settings_modal = false">Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>

    </div>
</template>

<script>
    import { mapGetters, mapMutations } from 'vuex'
    import Swal from 'sweetalert2'

    export default {

        data() {
            return {
                app: this.$root.$data.app,
                show_settings_modal: false,
                all_collection_points: [],
            }
        },

        mounted(){
            if(this.user){
                this.getSettings();
                if(Notification.permission === 'default'){
                    Notification.requestPermission().then(function(permission) {

                    });
                }
            }
        },

        methods: {
            ...mapMutations([
                'setToken',
                'setLoading',
                'configSession',
                'logout',
                'setSoundSetting',
                'setSearchSetting',
                'setCollectionPoints',
                'setIgnoreCollectionPoints',
                'setStoreStatus',
                'setTokenChecked',
            ]),

            getSettings(){
                this.app.http.get('order_collect/settings')
                    .then(response => {
                        this.all_collection_points = response.data.data.collection_points
                        this.setTokenChecked(true)
                    })
                    .catch(error => {
                        Swal.fire({
                            icon: 'error',
                            text: error.response.data.error,
                        })
                    })
            },

            confirmLogout(){
                Swal.fire({
                    title: 'Confirm',
                    text: 'Logout from this session?',
                    showCancelButton: true,
                    type:'question',
                    confirmButtonText: 'Logout'
                }).then((isConfirm) => {
                    if(isConfirm.value) {
                        this.setLoading(true)
                        this.app.http.post(`${env.base_api_url}logout`)
                            .then(response => {
                                this.logout()
                                console.log('logged out', response)
                            })
                    }
                })
            },

            toggleStatus(){
                this.app.http.post('order_collect/settings',{store_is_offline: this.store_is_offline === 0})
                    .then(response => {
                        this.setStoreStatus((this.store_is_offline == 1) ? 0 : 1)
                    })
                    .catch(error => {
                        console.log(error)
                        Swal.fire({
                            icon: 'error',
                            text: "Could not change status", //error.response.data.error
                        })
                    })
            },

            toggleSound(){
                this.setSoundSetting(!this.sound_enabled)
            },

            toggleSearch(){
                this.setSearchSetting(!this.order_search_enabled)
            },

            toggleCollectionPoint(point){
                let index = this.collection_points.indexOf(point.id)
                if (index != -1)
                    this.collection_points.splice(index, 1)
                else
                    this.collection_points.push(point.id)
                this.setCollectionPoints(this.collection_points)
            },

            toggleShowAll(){
                this.setIgnoreCollectionPoints(!this.ignore_collection_points)
            },

            showDebugModal(){
                const text = `${this.client.name} - ${this.outlet.name}`
                Swal.fire({
                    text,
                    icon: 'success',
                })
            },
        },

        computed: {

            ...mapGetters([
                'user',
                'client',
                'outlet',
                'logo',
                'loading',
                'store_is_offline',
                'order_search_enabled',
                'sound_enabled',
                'collection_points',
                'ignore_collection_points',
                'partner_source',
                'colour_theme',
            ]),

            navbar_colour() {

                if (this.partner_source == 'sumup')
                    return '#3388ff'

                return this.colour_theme.primary
            }
        },

         watch: {
            user: function(val) {
                if(val){
                    this.getSettings();
                    this.$router.replace({name: 'home'})
                }
            }
        }
    }
</script>

<style scoped>
    .font-14 {
        font-size: 14px;
    }

    .accepting {
        color: #38dab4;
    }

    .col-white {
        color: white;
    }

    .btn-accepting-orders {
        /* width: 30px; */
        line-height: 12px;
        background-color: transparent;
    }

    #header-main-text {
        color: whitesmoke
    }

    .header-name {
        font-size: 16px;
        color: whitesmoke;
    }

    .btn-logout {
        width: 120px;
    }
</style>
<style>
    .theme-blue-dark {
        color: #135 !important;
    }

    .bg-whitesmoke {
        background-color: whitesmoke;
    }

    #loading-mask .modal-dialog {
        width: 200px;
    }

    #loading-mask {
        z-index: 9998;
    }

    .modal-mask {
        position: fixed;
        z-index: 2;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .3s ease;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }

    .btn-reject:hover {
        color: red
    }

    .bg-dark-blue {
        background-color: #123c5e;
    }

    .phone-number {
        color: inherit;
    }

    .phone-number:hover {
        text-decoration: none;
    }

    .btn.active {
        background-color: red;
    }

    .btn {
        font-size: 14px;
        height: 40px
    }

    .btn-dark-bg {
        background-color: #343f4b;
        color: #fff
    }

    .custom-header {
        font-size: 16px;
        color: grey;
        text-transform: uppercase;
        padding-bottom: 5px;
    }

    .custom-header-min {
        font-size: 13px;
        color: grey;
        text-transform: uppercase;
    }

    .custom-header-big {
        font-size: 15px;
        color: grey;
        text-transform: uppercase;
        font-weight: 500;
    }

    .btn-success {
        background-color: #38dab4 !important;
        border-color: #38dab4 !important;
    }

    .btn-danger {
        background-color: #f06661 !important;
        border-color: #f06661 !important;
    }

    /* toggle switches*/
    .switch {
        position: relative;
        display: inline-block;
        width: 60px;
        height: 34px;
    }

    .switch input {
        opacity: 0;
        width: 0;
        height: 0;
    }

    .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #ccc;
        -webkit-transition: .4s;
        transition: .4s;
    }

    .slider:before {
        position: absolute;
        content: "";
        height: 26px;
        width: 26px;
        left: 4px;
        bottom: 4px;
        background-color: white;
        -webkit-transition: .4s;
        transition: .4s;
    }

    input:checked + .slider {
        background-color: #4cd964;
    }

    input:focus + .slider {
        box-shadow: 0 0 1px #4cd964;
    }

    input:checked + .slider:before {
        -webkit-transform: translateX(26px);
        -ms-transform: translateX(26px);
        transform: translateX(26px);
    }

    .slider.round {
        border-radius: 34px;
    }

    .slider.round:before {
        border-radius: 50%;
    }
    /* end */
    * {
        font-family: 'Muli', sans-serif !important;
    }
</style>